/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use client'

import type { ComponentProps, ReactNode } from 'react'
import { forwardRef } from 'react'

import { cn } from '@/lib/utils'

export interface BottomNavProps extends ComponentProps<'div'> {
  children: ReactNode
}

export const BottomNav = forwardRef<HTMLDivElement, BottomNavProps>(function BottomNav(props, ref) {
  const { children, className, ...rest } = props

  return (
    <div
      className={cn(
        'fixed right-0 bottom-0 left-0 z-40 flex w-full border-border border-t bg-background pb-[env(safe-area-inset-bottom)] md:hidden',
        className
      )}
      ref={ref}
      {...rest}
    >
      <div className="flex min-h-14 w-full items-center gap-0 px-2 py-1">{children}</div>
    </div>
  )
})

BottomNav.displayName = 'BottomNav'
